<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar v-if="this.paymentData.tranMode !== 'R'" dense color="grey lighten-3" flat>
              <v-icon>mdi-plus</v-icon>
              <v-toolbar-title>Create New Payment</v-toolbar-title>
            </v-toolbar>
            <v-toolbar v-if="this.paymentData.tranMode === 'R'" dense color="grey lighten-3" flat>
              <v-icon>mdi-pencil</v-icon>
              <v-toolbar-title>Edit Payment </v-toolbar-title>
            </v-toolbar>
            <v-tabs v-model="tabNav">
              <v-tab @click.native="doMandatory(0)">Mandatory</v-tab>
              <v-tab @click.native="doOptional(1)">Optional</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabNav" touchless>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="mandatory" eager>
                <form data-vv-scope="paymentMandatoryForm">
                  <v-flex xs12>
                    <v-expansion-panels :value="headerPanel" multiple>
                      <v-expansion-panel>
                        <v-expansion-panel-header><div><v-icon>mdi-filter-variant</v-icon> Headers </div></v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-card-text>
                            <v-container fluid grid-list-lg>
                              <v-layout row wrap>
                                <v-flex md6 xs12>
                                  <v-autocomplete
                                    :items="branches"
                                    v-model="mulAcctPayForm.branch"
                                    :label="mulAcctPayLabel.branch"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="mulAcctPayForm.branch"
                                    :data-vv-as="mulAcctPayLabel.branch"
                                    :error-messages="errors.collect('mulAcctPayForm.branch')"
                                    @change="doGetDefaultBankNo()"
                                    clearable
                                    v-validate="'required'"
                                    :disabled="this.paymentData.tranMode === 'R' || this.defaultForm.isDisabled"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex md2 xs12>
                                  <v-checkbox
                                    color="primary"
                                    :label="mulAcctPayLabel.docAE"
                                    v-model="mulAcctPayForm.docAE"
                                    @change="checkDocAE($event)"
                                    :disabled="this.paymentData.tranMode === 'R' || this.defaultForm.isDisabled"
                                  ></v-checkbox>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="mulAcctPayForm.documentNo"
                                    :disabled="isDisabledDocNo || this.paymentData.tranMode === 'R' || this.defaultForm.isDisabled"
                                    :label="mulAcctPayLabel.documentNo"
                                    :error-messages="errors.collect('mulAcctPayForm.documentNo')"
                                    data-vv-name="mulAcctPayForm.documentNo"
                                    :data-vv-as="mulAcctPayLabel.documentNo"
                                    @blur="checkDocNo"
                                    v-validate="docNoValidation"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md6 xs12>
                                  <cal-picker
                                    v-model="mulAcctPayForm.transactionDate"
                                    :label="mulAcctPayLabel.transactionDate"
                                    :disabled="this.defaultForm.isDisabled"
                                    :data-vv-as="mulAcctPayLabel.transactionDate"
                                    data-vv-name="mulAcctPayForm.transactionDate"
                                    :error-messages="errors.collect('mulAcctPayForm.transactionDate')"
                                    v-validate="'required'"
                                    :min="this.parseDateISO(this.tDateRange.effDate)"
                                    :max="this.parseDateISO(this.tDateRange.expDate)"
                                  ></cal-picker>
                                </v-flex>
                                <v-flex md3 xs12>
                                  <v-autocomplete
                                    :items="banks"
                                    v-model="mulAcctPayForm.fromBank"
                                    item-text="label"
                                    item-value="value"
                                    :label="mulAcctPayLabel.fromBank"
                                    :error-messages="errors.collect('mulAcctPayForm.fromBank')"
                                    data-vv-name="mulAcctPayForm.fromBank"
                                    :data-vv-as="mulAcctPayLabel.fromBank"
                                    v-validate="'required'"
                                    @change="getBankInfo($event)"
                                    clearable
                                    :disabled="this.paymentData.tranMode === 'R' || this.defaultForm.isDisabled"
                                  >
                                    <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                      <v-icon
                                        color="info"
                                        @click="showBankNoHelpList = true"
                                        :disabled="this.defaultForm.isDisabled || this.initDisabled"
                                      >mdi-magnify</v-icon>
                                    </v-slide-x-reverse-transition>
                                  </v-autocomplete>
                                </v-flex>
                                <v-flex md3 xs12>
                                  <v-autocomplete
                                    :items="funds"
                                    v-model="mulAcctPayForm.fund"
                                    :label="mulAcctPayLabel.fund"
                                    :disabled="true"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="mulAcctPayForm.fund"
                                    :data-vv-as="mulAcctPayLabel.fund"
                                    :error-messages="errors.collect('mulAcctPayForm.fund')"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex md4 xs12>
                                  <v-text-field
                                    v-model="mulAcctPayForm.chequeNo"
                                    :label="mulAcctPayLabel.chequeNo"
                                    :error-messages="errors.collect('mulAcctPayForm.chequeNo')"
                                    data-vv-name="mulAcctPayForm.chequeNo"
                                    :data-vv-as="mulAcctPayLabel.chequeNo"
                                    v-validate="chequeNoValidation"
                                    :disabled="this.defaultForm.isDisabled"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex md2 xs12>
                                  <v-checkbox
                                    color="primary"
                                    :label="mulAcctPayLabel.prtCheque"
                                    v-model="mulAcctPayForm.prtCheque"
                                    :disabled="this.defaultForm.isDisabled"
                                  ></v-checkbox>
                                </v-flex>
                                <v-flex md2 xs12>
                                  <v-autocomplete
                                    :items="gstIO"
                                    v-model="mulAcctPayForm.gstIO"
                                    :label="mulAcctPayLabel.gstIO"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="gstIO"
                                    :data-vv-as="mulAcctPayLabel.gstIO"
                                    :error-messages="errors.collect('gstIO')"
                                    @change="changeGstIO($event)"
                                    :disabled="this.defaultForm.isDisabled || this.initDisabled"
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex md2 xs12>
                                  <v-autocomplete
                                    :items="gstStatuses"
                                    v-model="mulAcctPayForm.gstStatus"
                                    :label="mulAcctPayLabel.gstStatus"
                                    item-text="label"
                                    item-value="value"
                                    data-vv-name="gstStatus"
                                    :data-vv-as="mulAcctPayLabel.gstStatus"
                                    :error-messages="errors.collect('gstStatus')"
                                    @change="changeGstRate($event)"
                                    disabled
                                  ></v-autocomplete>
                                </v-flex>
                                <v-flex md2 xs12>
                                  <v-text-field
                                    v-model="mulAcctPayForm.gstRate"
                                    :label="mulAcctPayLabel.gstRate"
                                    disabled
                                    hide-details:error-messages="errors.collect('mulAcctPayForm.gstRate')"
                                    data-vv-name="mulAcctPayForm.gstRate"
                                    :data-vv-as="mulAcctPayLabel.gstRate"
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card-text>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="accounts"
                                v-model="mulAcctPayForm.payTo"
                                item-text="label"
                                item-value="value"
                                :label="mulAcctPayLabel.payTo"
                                :error-messages="errors.collect('mulAcctPayForm.payTo')"
                                data-vv-name="mulAcctPayForm.payTo"
                                :data-vv-as="mulAcctPayLabel.payTo"
                                v-validate="'required'"
                                @change="getPayToAcctInfo($event)"
                                clearable
                                :disabled="this.initDisabled"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon
                                    color="info"
                                    @click="showPayToHelpList = true"
                                    :disabled="this.initDisabled"
                                  >mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="acctnosuffixes"
                                v-model="mulAcctPayForm.accountNoSuffix"
                                item-text="label"
                                item-value="value"
                                :label="mulAcctPayLabel.accountNoSuffix"
                                :error-messages="errors.collect('mulAcctPayForm.accountNoSuffix')"
                                data-vv-name="mulAcctPayForm.accountNoSuffix"
                                :data-vv-as="mulAcctPayLabel.accountNoSuffix"
                                v-validate="'required|entry|max:60'"
                                @change="getAcctNoSfxInfo($event)"
                                clearable
                                :disabled="this.initDisabled"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon
                                    color="info"
                                    @click="showAcctSufHelpList = true"
                                    :disabled="this.initDisabled"
                                  >mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="amountcurrencies"
                                v-model="mulAcctPayForm.amountCurr"
                                :label="mulAcctPayLabel.amountCurr"
                                item-text="label"
                                item-value="value"
                                :error-messages="errors.collect('mulAcctPayForm.amountCurr')"
                                data-vv-name="mulAcctPayForm.amountCurr"
                                :data-vv-as="mulAcctPayLabel.amountCurr"
                                v-validate="'required'"
                                clearable
                                :disabled="this.defaultForm.isDisabled || this.initDisabled || this.payBankCurr === true"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon
                                    color="info"
                                    @click="showCurrencyHelpList = true"
                                    :disabled="this.defaultForm.isDisabled || this.initDisabled"
                                  >mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="amount"
                                v-model="mulAcctPayForm.amount"
                                :label="mulAcctPayLabel.amount"
                                :error-messages="errors.collect('mulAcctPayForm.amount')"
                                data-vv-name="mulAcctPayForm.amount"
                                :data-vv-as="mulAcctPayLabel.amount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'required|mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:0.01'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="mulAcctPayForm.gstAmountCurr"
                                :label="mulAcctPayLabel.gstAmountCurr"
                                :disabled="true"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctPayForm.gstAmountCurr"
                                :data-vv-as="mulAcctPayLabel.gstAmountCurr"
                                :error-messages="errors.collect('mulAcctPayForm.gstAmountCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox
                                color="primary"
                                :label="mulAcctPayLabel.gstAmountAE"
                                :disabled="isGstAmtAE"
                                v-model="mulAcctPayForm.gstAmountAE"
                                @change="calculateAmount()"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                ref="gstAmount"
                                v-model="mulAcctPayForm.gstAmount"
                                :label="mulAcctPayLabel.gstAmount"
                                :disabled="isGstAmt"
                                :error-messages="errors.collect('mulAcctPayForm.gstAmount')"
                                data-vv-name="mulAcctPayForm.gstAmount"
                                :data-vv-as="mulAcctPayLabel.gstAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:0.00'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="mulAcctPayForm.netAmountCurr"
                                :label="mulAcctPayLabel.netAmountCurr"
                                :disabled="true"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctPayForm.netAmountCurr"
                                :data-vv-as="mulAcctPayLabel.netAmountCurr"
                                :error-messages="errors.collect('mulAcctPayForm.netAmountCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                v-model="mulAcctPayForm.netAmount"
                                :label="mulAcctPayLabel.netAmount"
                                :disabled="true"
                                :error-messages="errors.collect('mulAcctPayForm.netAmount')"
                                data-vv-name="mulAcctPayForm.netAmount"
                                :data-vv-as="mulAcctPayLabel.netAmount"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="mulAcctPayForm.bankAmountCurr"
                                :label="mulAcctPayLabel.bankAmountCurr"
                                :disabled="true"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctPayForm.bankAmountCurr"
                                :data-vv-as="mulAcctPayLabel.bankAmountCurr"
                                :error-messages="errors.collect('mulAcctPayForm.bankAmountCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox
                                color="primary"
                                :label="mulAcctPayLabel.bankAmountAE"
                                v-model="mulAcctPayForm.bankAmountAE"
                                @change="calculateAmount()"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                ref="bankAmount"
                                v-model="mulAcctPayForm.bankAmount"
                                :label="mulAcctPayLabel.bankAmount"
                                :disabled="isBankAmt"
                                :error-messages="errors.collect('mulAcctPayForm.bankAmount')"
                                data-vv-name="mulAcctPayForm.bankAmount"
                                :data-vv-as="mulAcctPayLabel.bankAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:0.00'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="mulAcctPayForm.bankChargesCurr"
                                :label="mulAcctPayLabel.bankChargesCurr"
                                :disabled="true"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctPayForm.bankChargesCurr"
                                :data-vv-as="mulAcctPayLabel.bankChargesCurr"
                                :error-messages="errors.collect('mulAcctPayForm.bankChargesCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="bankCharges"
                                v-model="mulAcctPayForm.bankCharges"
                                :label="mulAcctPayLabel.bankCharges"
                                :error-messages="errors.collect('mulAcctPayForm.bankCharges')"
                                data-vv-name="mulAcctPayForm.bankCharges"
                                :data-vv-as="mulAcctPayLabel.bankCharges"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="mulAcctPayForm.bankTotalAmountCurr"
                                :label="mulAcctPayLabel.bankTotalAmountCurr"
                                :disabled="true"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctPayForm.bankTotalAmountCurr"
                                :data-vv-as="mulAcctPayLabel.bankTotalAmountCurr"
                                :error-messages="errors.collect('mulAcctPayForm.bankTotalAmountCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="bankTotalAmount"
                                v-model="mulAcctPayForm.bankTotalAmount"
                                :label="mulAcctPayLabel.bankTotalAmount"
                                disabled
                                :error-messages="errors.collect('mulAcctPayForm.bankTotalAmount')"
                                data-vv-name="mulAcctPayForm.bankTotalAmount"
                                :data-vv-as="mulAcctPayLabel.bankTotalAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="mulAcctPayForm.bankTotalLocalCurr"
                                disabled
                                :label="mulAcctPayLabel.bankTotalLocalCurr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctPayForm.bankTotalLocalCurr"
                                :data-vv-as="mulAcctPayLabel.bankTotalLocalCurr"
                                :error-messages="errors.collect('mulAcctPayForm.bankTotalLocalCurr')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox
                                color="primary"
                                :label="mulAcctPayLabel.bankTotalLocalAE"
                                v-model="mulAcctPayForm.bankTotalLocalAE"
                                @change="calculateAmount()"
                                :disabled="isEqualAmtCurr"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                ref="bankTotalLocal"
                                v-model="mulAcctPayForm.bankTotalLocal"
                                :label="mulAcctPayLabel.bankTotalLocal"
                                :disabled="isBankTotLoc"
                                :error-messages="errors.collect('mulAcctPayForm.bankTotalLocal')"
                                data-vv-name="mulAcctPayForm.bankTotalLocal"
                                :data-vv-as="mulAcctPayLabel.bankTotalLocal"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:0.00'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-if="isNew">
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ createdName + ' on ' + nowDT }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-else>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.createdBy + ' on ' + mulAcctPayForm.createdDate }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-if="isNew">
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ createdName + ' on ' + nowDT }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-else>
                              <v-subheader class="queryLabel">{{ mulAcctPayLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ mulAcctPayForm.modifiedBy + ' on ' + mulAcctPayForm.modifiedDate }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="optional" eager>
                <form data-vv-scope="paymentOptionalForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <div class="header-padding body-2">Document Details</div>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="printDocOpts"
                                v-model="mulAcctPayForm.printDocument"
                                :label="mulAcctPayLabel.printDocument"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctPayForm.printDocument"
                                :data-vv-as="mulAcctPayLabel.printDocument"
                                :error-messages="errors.collect('mulAcctPayForm.printDocument')"
                                :disabled="this.defaultForm.isDisabled"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="addressToOpts"
                                v-model="mulAcctPayForm.addressTo"
                                :label="mulAcctPayLabel.addressTo"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctPayForm.addressTo"
                                :data-vv-as="mulAcctPayLabel.addressTo"
                                :error-messages="errors.collect('mulAcctPayForm.addressTo')"
                                @change="promptRemoveNameAddr = true"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                v-model="mulAcctPayForm.policyNo"
                                :label="mulAcctPayLabel.policyNo"
                                :error-messages="errors.collect('mulAcctPayForm.policyNo')"
                                data-vv-name="mulAcctPayForm.policyNo"
                                :data-vv-as="mulAcctPayLabel.policyNo"
                                v-validate="'entry|max:60'"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showAcctPolicyHelpList = true">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                v-model="mulAcctPayForm.companyName"
                                :label="mulAcctPayLabel.companyName"
                                :error-messages="errors.collect('mulAcctPayForm.companyName')"
                                data-vv-name="mulAcctPayForm.companyName"
                                :data-vv-as="mulAcctPayLabel.companyName"
                                v-validate="'entry|max:100|sanction:' + sanctionName1Error"
                                @change="valSanction(mulAcctPayForm.companyName, '', 'sanctionName1Error')"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="mulAcctPayForm.docAddress1"
                                :label="mulAcctPayLabel.docAddress1"
                                :error-messages="errors.collect('mulAcctPayForm.docAddress1')"
                                data-vv-name="mulAcctPayForm.docAddress1"
                                :data-vv-as="mulAcctPayLabel.docAddress1"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="mulAcctPayForm.docAddress2"
                                :label="mulAcctPayLabel.docAddress2"
                                :error-messages="errors.collect('mulAcctPayForm.docAddress2')"
                                data-vv-name="mulAcctPayForm.docAddress2"
                                :data-vv-as="mulAcctPayLabel.docAddress2"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="mulAcctPayForm.docAddress3"
                                :label="mulAcctPayLabel.docAddress3"
                                :error-messages="errors.collect('mulAcctPayForm.docAddress3')"
                                data-vv-name="mulAcctPayForm.docAddress3"
                                :data-vv-as="mulAcctPayLabel.docAddress3"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="mulAcctPayForm.docAddress4"
                                :label="mulAcctPayLabel.docAddress4"
                                :error-messages="errors.collect('mulAcctPayForm.docAddress4')"
                                data-vv-name="mulAcctPayForm.docAddress4"
                                :data-vv-as="mulAcctPayLabel.docAddress4"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                v-model="mulAcctPayForm.postalCode"
                                :label="mulAcctPayLabel.postalCode"
                                :error-messages="errors.collect('mulAcctPayForm.postalCode')"
                                data-vv-name="mulAcctPayForm.postalCode"
                                :data-vv-as="mulAcctPayLabel.postalCode"
                                v-validate="'entry|numeric|max:8'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="mulAcctPayForm.details"
                                :label="mulAcctPayLabel.details"
                                :error-messages="errors.collect('mulAcctPayForm.details')"
                                data-vv-name="mulAcctPayForm.details"
                                :data-vv-as="mulAcctPayLabel.details"
                                v-validate="'entry|max:120'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="mulAcctPayForm.statementRef"
                                :label="mulAcctPayLabel.statementRef"
                                :error-messages="errors.collect('mulAcctPayForm.statementRef')"
                                data-vv-name="mulAcctPayForm.statementRef"
                                :data-vv-as="mulAcctPayLabel.statementRef"
                                v-validate="'entry|max:200'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <div class="header-padding body-2">Other Details</div>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-autocomplete
                                :items="departments"
                                v-model="mulAcctPayForm.department"
                                :label="mulAcctPayLabel.department"
                                item-text="label"
                                item-value="value"
                                data-vv-name="mulAcctPayForm.department"
                                :data-vv-as="mulAcctPayLabel.department"
                                :error-messages="errors.collect('mulAcctPayForm.department')"
                                v-validate="deptValidation"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="mulAcctPayForm.insuredName"
                                :label="mulAcctPayLabel.insuredName"
                                :error-messages="errors.collect('mulAcctPayForm.insuredName')"
                                data-vv-name="mulAcctPayForm.insuredName"
                                :data-vv-as="mulAcctPayLabel.insuredName"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="mulAcctPayForm.claimNo"
                                :label="mulAcctPayLabel.claimNo"
                                :error-messages="errors.collect('mulAcctPayForm.claimNo')"
                                data-vv-name="mulAcctPayForm.claimNo"
                                :data-vv-as="mulAcctPayLabel.claimNo"
                                v-validate="'entry|max:60'"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showClmHelpList = true">mdi-magnify</v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="mulAcctPayForm.gstRegNo"
                                :label="mulAcctPayLabel.gstRegNo"
                                :error-messages="errors.collect('mulAcctPayForm.gstRegNo')"
                                data-vv-name="mulAcctPayForm.gstRegNo"
                                :data-vv-as="mulAcctPayLabel.gstRegNo"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="mulAcctPayForm.taxInvoiceNo"
                                :label="mulAcctPayLabel.taxInvoiceNo"
                                :error-messages="errors.collect('mulAcctPayForm.taxInvoiceNo')"
                                data-vv-name="mulAcctPayForm.taxInvoiceNo"
                                :data-vv-as="mulAcctPayLabel.taxInvoiceNo"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
            </v-tabs-items>
            <v-flex xs12 v-if="this.btnSaveList === false">
              <v-btn class="mr-2" color="primary" dark @click.prevent="doAddAccount" :loading="submitting">
                {{ actionLabel.addAccount }}
                <v-icon dark right>mdi-plus</v-icon>
              </v-btn>
            </v-flex>
            <v-flex xs12 v-if="this.btnSaveList === true">
              <v-card-actions>
                <v-btn color="error" dark @click.prevent="doCancelAccount" :loading="submitting">
                  {{ actionLabel.cancelAccount }}
                  <v-icon dark right>mdi-close</v-icon>
                </v-btn>
                <v-btn color="primary" dark @click.prevent="doSaveAccount" :loading="submitting">
                  {{ actionLabel.saveAccount }}
                  <v-icon dark right>mdi-content-save</v-icon>
                </v-btn>
              </v-card-actions>
            </v-flex>
            <v-flex xs12 class="mt-3">
              <v-card>
                <v-data-table
                  v-bind:headers="listMulAcctPayHeaders"
                  v-bind:items="accountList"
                  item-key="key"
                  :loading="loading"
                  :no-data-text="noDataText"
                >
                  <template v-slot:item="row"
                    ><tr>
                      <td v-for="column in selectAcctPayColumns" :key="column">{{ row.item[column] }}</td>
                      <td class="table-action-header">
                        <table-action :rowData="row" review @review="doReview(row.item)" remove @remove="doRemove(row)"></table-action>
                      </td></tr
                  ></template>
                </v-data-table>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h3><u>Grand Total </u></h3>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.payment"
                          :label="grandTotLabel.payment"
                          disabled
                          :error-messages="errors.collect('grandTotForm.payment')"
                          data-vv-name="grandTotForm.payment"
                          :data-vv-as="grandTotLabel.payment"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.gst"
                          :label="grandTotLabel.gst"
                          disabled
                          :error-messages="errors.collect('grandTotForm.gst')"
                          data-vv-name="grandTotForm.gst"
                          :data-vv-as="grandTotLabel.gst"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.net"
                          :label="grandTotLabel.net"
                          disabled
                          :error-messages="errors.collect('grandTotForm.net')"
                          data-vv-name="grandTotForm.net"
                          :data-vv-as="grandTotLabel.net"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.bankAmt"
                          :label="grandTotLabel.bankAmt"
                          disabled
                          :error-messages="errors.collect('grandTotForm.bankAmt')"
                          data-vv-name="grandTotForm.bankAmt"
                          :data-vv-as="grandTotLabel.bankAmt"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.charges"
                          :label="grandTotLabel.charges"
                          disabled
                          :error-messages="errors.collect('grandTotForm.charges')"
                          data-vv-name="grandTotForm.charges"
                          :data-vv-as="grandTotLabel.charges"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.total"
                          :label="grandTotLabel.total"
                          disabled
                          :error-messages="errors.collect('grandTotForm.total')"
                          data-vv-name="grandTotForm.total"
                          :data-vv-as="grandTotLabel.total"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md4 xs12>
                        <v-text-field
                          v-model="grandTotForm.localTotal"
                          :label="grandTotLabel.localTotal"
                          disabled
                          :error-messages="errors.collect('grandTotForm.localTotal')"
                          data-vv-name="grandTotForm.localTotal"
                          :data-vv-as="grandTotLabel.localTotal"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-card-actions>
              <v-btn color="error" dark @click.prevent="doCancel">
                {{ actionLabel.cancel }}
                <v-icon dark right>mdi-exit-to-app</v-icon>
              </v-btn>
              <v-btn color="info" dark @click.prevent="doSavePayment('CREATE_SAVE_REVIEW')" :loading="submitting">
                {{ actionLabel.saveAndReview }}
                <v-icon dark right>mdi-content-save</v-icon>
              </v-btn>
              <v-btn color="primary" dark @click.prevent="doSavePayment('CREATE_SAVE_POST')" :loading="submitting">
                {{ actionLabel.saveAndPost }}
                <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>

      <v-dialog v-model="showPayToHelpList" width="1280px">
        <acct-no-help-list @close="showPayToHelpList = false" @assign-acct-info="assignAcctInfo"></acct-no-help-list>
      </v-dialog>

      <v-dialog v-model="showBankNoHelpList" width="1280px">
        <bank-help-list @close="showBankNoHelpList = false" @assign-bank-info="assignBankInfo" :objData="bankHelpListScreen"></bank-help-list>
      </v-dialog>

      <v-dialog v-model="showAcctSufHelpList" width="1280px">
        <acct-suf-help-list @close="showAcctSufHelpList = false" @assign-acct-suf-info="assignAcctSufInfo"></acct-suf-help-list>
      </v-dialog>

      <v-dialog v-model="showCurrencyHelpList" width="1280px">
        <currency-help-list @close="showCurrencyHelpList = false" @assign-currency-info="assignCurrencyInfo"></currency-help-list>
      </v-dialog>

      <v-dialog v-model="showAcctPolicyHelpList" width="1280px">
        <acct-policy-help-list
          :accountNo="mulAcctPayForm.payTo"
          :boolPolRefresh="showAcctPolicyHelpList"
          @close="showAcctPolicyHelpList = false"
          @assign-policy-info="assignPolicyInfo"
        ></acct-policy-help-list>
      </v-dialog>

      <v-dialog v-model="showClmHelpList" width="1280px">
        <claim-help-list
          @close="showClmHelpList = false"
          @assign-claim-no="assignClaimNo"
          :boolRefresh="showClmHelpList"
          :accountNo="mulAcctPayForm.payTo"
        ></claim-help-list>
      </v-dialog>

      <v-dialog v-model="processingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <warning v-model="promptMsg" :label="errMsg" :showAcceptBtn="isWarning" @ok="acceptInterWarn = true"/>
      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">System Information</div>
              <span class="grey--text">An error occurred when creating payment.</span>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Error Details:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <warning v-model="promptDuplicateAccount">
        <p>This Account No and Suffix already created</p>
        Account No.: {{ duplicateForm.acctNo }}<br />
        Suffix: {{ duplicateForm.suffix }}
      </warning>
      <!--LYT Added: 2020-08-27  Sanction Partial Matched Names List -->
      <v-dialog v-model="showSanctionDialog" width="1280px">
        <sanction-partial-match-list :sanctionItems="sanctionPartialMatchItems" @close="showSanctionDialog = false"></sanction-partial-match-list>
      </v-dialog>
      <prompt-leave
        v-if="showPromptLeave"
        title="Multiple Account Payment"
        :tranMode="this.paymentData.tranMode"
        v-model="promptLeave"
        @exit="doExit"
        @saveAndExit="doSaveAndExit"
      ></prompt-leave>

      <confirm v-model="promptConfirmation" @ok="doProceed" @cancel="processingFlag = false">
        <p>Cheque No. is existing in other payment, do you want to proceed?</p>
        <div class="queryValue">
          Bank No. : {{ this.mulAcctPayForm.fromBank }}<br />
          Cheque No. : {{ this.mulAcctPayForm.chequeNo }}<br />
        </div>
      </confirm>
      <confirm v-model="promptRemoveNameAddr" @ok="doRemoveNameAddr">
        {{ promptRemoveNameAddrMsg }}
      </confirm>
    </v-container>

    <warning v-model="promptWarning" :label="warningMsg" :info="true"/>

    <v-dialog v-model="loadingFlag" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import AcctNoHelpList from '@/components/core/common/dialog/AcctNoHelpList'
import BankHelpList from '@/components/core/common/dialog/BankHelpList'
import AcctSufHelpList from '@/components/core/common/dialog/AcctSufHelpList'
import CurrencyHelpList from '@/components/core/common/dialog/CurrencyHelpList'
import { removeFormatNumber } from '@/utils/number'
import AcctPolicyHelpList from '@/components/core/common/dialog/AcctPolicyHelpList'
import ClaimHelpList from '@/components/core/common/dialog/ClaimHelpList'
import { promptOnExitMixin } from '@/mixins/common/promptOnExitMixin'
import PromptLeave from '@/components/core/common/prompt/PromptLeave'
import { formatPrice } from '@/utils/index'
import { parseISO } from 'date-fns'
import * as TableConst from '@/mixins/table'
import { formatDisplayDateTime2 } from '@/utils/date'
import { mulAcctPaymentAjaxMixin } from '@/mixins/accounting/payment/mulAcctPayt/mulAcctPaymentAjaxMixin'
import { mulAcctPaymentViewMixin } from '@/mixins/accounting/payment/mulAcctPayt/mulAcctPaymentViewMixin'
import { paymentAjaxMixin } from '@/mixins/accounting/payment/paymentAjaxMixin'
import SanctionPartialMatchList from '@/components/core/common/dialog/SanctionPartialMatchList'

export default {
  data() {
    return {
      tabNav: 0,
      loadingFlag: false,
      actionLabel: {
        cancel: 'Cancel',
        saveAndReview: 'Save & Review',
        saveAndPost: 'Save & Post',
        matchLater: 'Match Later',
        addAccount: 'Add Account',
        saveAccount: 'Save & Continue',
        cancelAccount: 'Cancel'
      },
      grandTotLabel: {
        payment: 'Payment',
        gst: 'GST',
        net: 'Net',
        bankAmt: 'Bank Amt',
        charges: 'Charges',
        total: 'Total',
        localTotal: 'Local Total'
      },
      grandTotForm: {
        payment: '0.00',
        gst: '0.00',
        net: '0.00',
        bankAmt: '0.00',
        charges: '0.00',
        total: '0.00',
        localTotal: '0.00'
      },
      defaultForm: {
        branch: null,
        documentNo: null,
        transactionType: null,
        docAE: true,
        transactionDate: null,
        chequeNo: null,
        prtCheque: false,
        fromBank: null,
        fund: null,
        gstIO: null,
        gstStatus: null,
        gstRate: (0.0).toFixed(2),
        amountCurr: null,
        bankAmountCurr: null,
        bankAmountCurrRate: (0.0).toFixed(2),
        amountCurrRate: (0.0).toFixed(2),
        bankChargesCurr: null,
        bankTotalAmountCurr: null,
        bankTotalLocalCurr: null,
        printDocument: null,
        isDisabled: false
      },
      duplicateForm: {
        acctNo: null,
        suffix: null
      },
      reviewForm: {
        accountNo: null,
        accountNoSuffix: null,
        branch: null,
        documentNo: null,
        fund: null,
        transactionType: null
      },
      validStatus: {
        mandatory: true,
        optional: true
      },
      miscacctparams: [],
      cashbooks: [],
      departments: [],
      checkTabData: false,
      loading: false,
      processingFlag: false,
      showErrorDialog: false,
      submitting: false,
      showPromptLeave: true,
      isMandatory: true,
      isOptional: false,
      accounts: [],
      accountdata: {},
      banks: [],
      bankdata: {},
      acctnosuffixes: [],
      acctnosuffixdata: {},
      amountcurrencies: [],
      amountcurrencydata: {},
      trandaterange: {},
      gstStatuses: [],
      branches: [],
      funds: [],
      gstrate: (0.0).toFixed(2),
      chequeNoForm: null,
      promptConfirmation: false,
      isExistChequeNo: false,
      currencyrate: {},
      existAcctPay: false,
      promptDuplicateAccount: false,
      headerPanel: [0],
      mulAcctPayMenu: {},
      initDisabled: false,
      promptWarning: false,
      isEqualAmtCurr: false,
      promptRemoveNameAddr: false,
      promptRemoveNameAddrMsg: 'Do you want to remove Name, Address(1-4), Postal Code?',
      payBankCurr: false,
      warningMsg: ''
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    'tDateRange.effDate': function () {
      if (this.tDateRange.effDate !== '' && this.paymentData.tranMode === '') {
        this.getCommonData('gstrate', this.mulAcctPayForm.gstStatus, formatDisplayDateTime2(this.mulAcctPayForm.transactionDate))
      }
    },
    'mulAcctPayForm.amountCurr': function () {
      if (this.mulAcctPayForm.amountCurr && this.mulAcctPayForm.transactionDate) {
        this.getCommonData('currencyrate', this.mulAcctPayForm.amountCurr, formatDisplayDateTime2(this.mulAcctPayForm.transactionDate))
      }
    },
    'mulAcctPayForm.transactionDate': function () {
      if (this.mulAcctPayForm.amountCurr && this.mulAcctPayForm.transactionDate) {
        this.getCommonData('currencyrate', this.mulAcctPayForm.amountCurr, formatDisplayDateTime2(this.mulAcctPayForm.transactionDate))
        this.getCommonData('bankcurrencyrate', this.mulAcctPayForm.fromBank, formatDisplayDateTime2(this.mulAcctPayForm.transactionDate))
      }
    }
  },
  computed: {
    paymentData() {
      return this.$store.state.payment.paymentData
    },
    displayErrorDialog() {
      return this.messages
    },
    isGstAmtAE: function () {
      if (this.mulAcctPayForm.gstIO === 'B') {
        return true
      } else {
        return false
      }
    },
    isDisabledDocNo: function () {
      return this.mulAcctPayForm.docAE
    },
    token() {
      return this.$store.state.token
    },
    isCashBook: function () {
      return this.miscacctparams.cashBkMand === null || this.miscacctparams.cashBkMand === false
    },
    isGstAmt: function () {
      return this.mulAcctPayForm.gstAmountAE
    },
    isBankAmt: function () {
      return this.mulAcctPayForm.bankAmountAE
    },
    isBankTotLoc: function () {
      if (this.isEqualAmtCurr) {
        return true
      } else {
        return this.mulAcctPayForm.bankTotalLocalAE
      }
    },
    docNoValidation() {
      if (this.mulAcctPayForm.docAE === false && (this.mulAcctPayForm.documentNo === null || this.mulAcctPayForm.documentNo === '')) {
        return 'required'
      } else {
        return 'entry|documentNo:' + this.mulAcctPayForm.isExistDocNo
      }
    },
    chequeNoValidation() {
      if (parseInt(this.chequeNoForm) === 0) {
        return 'required|max:10'
      } else if (this.chequeNoForm > 0) {
        return 'entry|chequeNo:' + this.chequeNoForm
      } else {
        return ''
      }
    },
    deptValidation() {
      if (this.miscacctparams.deptMand) {
        return 'required'
      } else {
        return ''
      }
    },
    tDateRange() {
      return this.trandaterange
    },
    listMulAcctPayHeaders() {
      let result = []
      for (const selectAcctPayColumns of this.selectAcctPayColumns) {
        let findCol = this.mulAcctPayColumns.find((a) => selectAcctPayColumns === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    },
    isNew() {
      return !(this.paymentData.tranMode === 'Q' || this.paymentData.tranMode === 'R')
    }
  },
  methods: {
    async doInit() {
      this.loadingFlag = true
      await Promise.all([this.$store.dispatch('commonsInit')])
      await Promise.all([this.$store.dispatch('paymentInit')])
      await Promise.all([this.$store.dispatch('reportsInit')])
      await Promise.all([this.$store.dispatch('acctReportsInit')])
      this.getAcctPaytVouMenuLink()
      this.getCommonData('miscacctparams', 'cash')
      this.getChequeNoForm()
      this.fetchBranch()
      this.fetchFund()
      this.fetchCurrency()
      this.fetchCashBook()
      this.fetchDepartment()
      this.fetchAccount()
      this.fetchBank()
      this.fetchAcctNoSfx()
      this.fetchAmountCurrency()
      this.fetchGstStatus()
      this.getCommonData('trandaterange', '004')
      this.bankHelpListScreen = 'screen_1'
      if (this.paymentData.tranMode === 'R') {
        await Promise.all([this.performReviewMultAcctPayt()])
      } else {
        this.doLaunch()
      }
      this.loadingFlag = false
    },
    async doLaunch() {
      this.initDisabled = false
      if (this.accountList.length === 0) {
        this.defaultForm.isDisabled = false
        this.headerPanel = [0]
        this.getCommonData('miscacctparams').then((result) => {
          this.mulAcctPayForm.printDocument = this.miscacctparams.defIlnpv
        })
        this.mulAcctPayForm.transactionType = 'Z'
        this.mulAcctPayForm.transactionDate = new Date()
        this.mulAcctPayForm.branch = this.token.userBranch
        this.mulAcctPayForm.gstIO = 'B'
        this.mulAcctPayForm.gstStatus = 'N'
        this.getBaseCurr(this.mulAcctPayForm)
        this.getDefaultBankNo(this.token.userBranch, this.mulAcctPayForm, 'payment').then((result) => {
          if (result) {
            this.checkTotAmtCurrCompanyCurr()
          }
        })
      } else {
        this.headerPanel = []
        this.mulAcctPayForm.branch = this.defaultForm.branch
        this.mulAcctPayForm.documentNo = this.defaultForm.documentNo
        this.mulAcctPayForm.transactionType = this.defaultForm.transactionType
        this.mulAcctPayForm.docAE = this.defaultForm.docAE
        this.mulAcctPayForm.transactionDate = this.defaultForm.transactionDate
        this.mulAcctPayForm.chequeNo = this.defaultForm.chequeNo
        this.mulAcctPayForm.prtCheque = this.defaultForm.prtCheque
        this.mulAcctPayForm.fromBank = this.defaultForm.fromBank
        this.mulAcctPayForm.fund = this.defaultForm.fund
        this.mulAcctPayForm.gstIO = this.defaultForm.gstIO
        this.mulAcctPayForm.gstStatus = this.defaultForm.gstStatus
        this.mulAcctPayForm.gstRate = this.defaultForm.gstRate
        this.mulAcctPayForm.amountCurr = this.defaultForm.amountCurr
        this.mulAcctPayForm.bankAmountCurr = this.defaultForm.bankAmountCurr
        this.mulAcctPayForm.bankAmountCurrRate = this.defaultForm.bankAmountCurrRate
        this.mulAcctPayForm.amountCurrRate = this.defaultForm.amountCurrRate
        this.mulAcctPayForm.bankChargesCurr = this.defaultForm.bankChargesCurr
        this.mulAcctPayForm.bankTotalAmountCurr = this.defaultForm.bankTotalAmountCurr
        this.mulAcctPayForm.bankTotalLocalCurr = this.defaultForm.bankTotalLocalCurr
        this.mulAcctPayForm.printDocument = this.defaultForm.printDocument

        this.getCommonData('currencyrate', this.mulAcctPayForm.amountCurr, formatDisplayDateTime2(this.mulAcctPayForm.transactionDate))
        this.getCommonData('bankcurrencyrate', this.mulAcctPayForm.fromBank, formatDisplayDateTime2(this.mulAcctPayForm.transactionDate))
      }
      this.mulAcctPayForm.gstAmountAE = true
      this.mulAcctPayForm.bankAmountAE = true
      this.mulAcctPayForm.bankTotalLocalAE = true
      this.mulAcctPayForm.addressTo = 'A'
    },
    doAddAccount() {
      this.existAcctPay = false
      this.processingFlag = true
      for (var i = 0; i < this.accountList.length; i++) {
        if (
          this.accountList[i].accountNo === this.mulAcctPayForm.accountNo &&
          this.accountList[i].accountNoSuffix === this.mulAcctPayForm.accountNoSuffix
        ) {
          this.duplicateForm.acctNo = this.mulAcctPayForm.accountNo
          this.duplicateForm.suffix = this.mulAcctPayForm.accountNoSuffix
          this.existAcctPay = true
        }
      }
      if (this.existAcctPay) {
        this.promptDuplicateAccount = true
        this.processingFlag = false
      } else {
        this.checkChequeNo()
      }
    },
    doGetDefaultBankNo() {
      this.getDefaultBankNo(this.mulAcctPayForm.branch, this.mulAcctPayForm, 'payment').then((result) => {
        if (result) {
          this.checkTotAmtCurrCompanyCurr()
        }
      })
    },
    checkTotAmtCurrCompanyCurr() {
      if (this.mulAcctPayForm.netAmountCurr === this.mulAcctPayForm.bankTotalLocalCurr) {
        this.mulAcctPayForm.bankTotalLocalAE = true
        this.isEqualAmtCurr = true
      } else {
        this.isEqualAmtCurr = false
      }
    },
    checkDocAE(event) {
      if (event) {
        this.mulAcctPayForm.documentNo = null
        this.resetMessages()
        this.resetValidator()
      }
    },
    doProceedSaveMulAcct() {
      if (this.accountList.length <= 1) {
        this.defaultForm.isDisabled = true
        this.defaultForm.branch = this.mulAcctPayForm.branch
        this.defaultForm.documentNo = this.mulAcctPayForm.documentNo
        this.defaultForm.transactionType = this.mulAcctPayForm.transactionType
        this.defaultForm.docAE = this.mulAcctPayForm.docAE
        this.defaultForm.transactionDate = this.mulAcctPayForm.transactionDate
        this.defaultForm.chequeNo = this.mulAcctPayForm.chequeNo
        this.defaultForm.prtCheque = this.mulAcctPayForm.prtCheque
        this.defaultForm.fromBank = this.mulAcctPayForm.fromBank
        this.defaultForm.fund = this.mulAcctPayForm.fund
        this.defaultForm.gstIO = this.mulAcctPayForm.gstIO
        this.defaultForm.gstStatus = this.mulAcctPayForm.gstStatus
        this.defaultForm.gstRate = this.mulAcctPayForm.gstRate
        this.defaultForm.amountCurr = this.mulAcctPayForm.amountCurr
        this.defaultForm.amountCurrRate = this.mulAcctPayForm.amountCurrRate
        this.defaultForm.bankAmountCurr = this.mulAcctPayForm.bankAmountCurr
        this.defaultForm.bankAmountCurrRate = this.mulAcctPayForm.bankAmountCurrRate
        this.defaultForm.amountCurrRate = this.mulAcctPayForm.amountCurrRate
        this.defaultForm.bankChargesCurr = this.mulAcctPayForm.bankChargesCurr
        this.defaultForm.bankTotalAmountCurr = this.mulAcctPayForm.bankTotalAmountCurr
        this.defaultForm.bankTotalLocalCurr = this.mulAcctPayForm.bankTotalLocalCurr
        this.defaultForm.printDocument = this.mulAcctPayForm.printDocument
      }
      const tempData = {
        branch: this.mulAcctPayForm.branch,
        accountNo: this.mulAcctPayForm.accountNo,
        documentNo: this.mulAcctPayForm.documentNo,
        transactionType: this.mulAcctPayForm.transactionType,
        docAE: this.mulAcctPayForm.docAE,
        transactionDate: this.mulAcctPayForm.transactionDate,
        payTo: this.mulAcctPayForm.payTo,
        bankNo: this.mulAcctPayForm.bankNo,
        fromBank: this.mulAcctPayForm.fromBank,
        fund: this.mulAcctPayForm.fund,
        accountNoSuffix: this.mulAcctPayForm.accountNoSuffix,
        cashBook: this.mulAcctPayForm.cashBook,
        gstIO: this.mulAcctPayForm.gstIO,
        gstStatus: this.mulAcctPayForm.gstStatus,
        gstRate: this.mulAcctPayForm.gstRate,
        amountCurr: this.mulAcctPayForm.amountCurr,
        amount: this.mulAcctPayForm.amount,
        gstAmountCurr: this.mulAcctPayForm.gstAmountCurr,
        amountCurrRate: this.mulAcctPayForm.amountCurrRate,
        gstAmountAE: this.mulAcctPayForm.gstAmountAE === true ? 'A' : 'E',
        gstAmount: this.mulAcctPayForm.gstAmount,
        netAmountCurr: this.mulAcctPayForm.netAmountCurr,
        netAmount: this.mulAcctPayForm.netAmount,
        bankAmountCurr: this.mulAcctPayForm.bankAmountCurr,
        bankAmountAE: this.mulAcctPayForm.bankAmountAE === true ? 'A' : 'E',
        bankAmount: this.mulAcctPayForm.bankAmount,
        bankAmountCurrRate: this.mulAcctPayForm.bankAmountCurrRate,
        bankChargesCurr: this.mulAcctPayForm.bankChargesCurr,
        bankCharges: this.mulAcctPayForm.bankCharges,
        bankTotalAmountCurr: this.mulAcctPayForm.bankTotalAmountCurr,
        bankTotalAmount: this.mulAcctPayForm.bankTotalAmount,
        bankTotalLocalCurr: this.mulAcctPayForm.bankTotalLocalCurr,
        bankTotalLocalAE: this.mulAcctPayForm.bankTotalLocalAE === true ? 'A' : 'E',
        bankTotalLocal: this.mulAcctPayForm.bankTotalLocal,
        bankTotalLocalCurrRate: this.mulAcctPayForm.bankTotalLocalCurrRate,
        chequeNo: this.mulAcctPayForm.chequeNo,
        prtCheque: this.mulAcctPayForm.prtCheque,
        isDeptMand: this.mulAcctPayForm.isDeptMand,
        printDocument: this.mulAcctPayForm.printDocument,
        addressTo: this.mulAcctPayForm.addressTo,
        policyNo: this.mulAcctPayForm.policyNo,
        insdRefNo: this.mulAcctPayForm.insdRefNo,
        companyName: this.mulAcctPayForm.companyName,
        docAddress1: this.mulAcctPayForm.docAddress1,
        docAddress2: this.mulAcctPayForm.docAddress2,
        docAddress3: this.mulAcctPayForm.docAddress3,
        docAddress4: this.mulAcctPayForm.docAddress4,
        postalCode: this.mulAcctPayForm.postalCode,
        details: this.mulAcctPayForm.details,
        statementRef: this.mulAcctPayForm.statementRef,
        department: this.mulAcctPayForm.department,
        insuredName: this.mulAcctPayForm.insuredName,
        claimNo: this.mulAcctPayForm.claimNo,
        gstRegNo: this.mulAcctPayForm.gstRegNo,
        taxInvoiceNo: this.mulAcctPayForm.taxInvoiceNo,
        isExistDocNo: this.mulAcctPayForm.isExistDocNo,
        saveStatus: 'true'
      }
      this.accountList.push(tempData)
      this.btnSaveList = false

      this.doReset()
    },
    doReset() {
      var thisForm = this.mulAcctPayForm
      Object.keys(this.mulAcctPayForm).forEach(function (key, index) {
        thisForm[key] = ''
      })

      thisForm = this.reviewForm
      Object.keys(this.reviewForm).forEach(function (key, index) {
        thisForm[key] = ''
      })
      this.btnSaveList = false
      this.initDisabled = false
      this.defaultForm.isDisabled = true
      this.processingFlag = false
      this.resetMessages()
      this.resetValidator()
      this.doAccumulate()
      this.doLaunch()
    },
    async doReview(data) {
      this.resetMessages()
      this.resetValidator()
      this.reviewForm.accountNo = data.accountNo
      this.reviewForm.accountNoSuffix = data.accountNoSuffix
      this.reviewForm.branch = data.branch
      this.reviewForm.documentNo = data.documentNo
      this.reviewForm.transactionType = data.transactionType
      this.reviewForm.fund = data.fund

      this.mulAcctPayForm.branch = data.branch
      this.mulAcctPayForm.accountNo = data.accountNo
      this.mulAcctPayForm.documentNo = data.documentNo
      this.mulAcctPayForm.transactionType = data.transactionType
      this.mulAcctPayForm.docAE = data.docAE === 'true' || data.docAE === true
      this.mulAcctPayForm.transactionDate = data.transactionDate
      this.mulAcctPayForm.payTo = data.payTo
      this.mulAcctPayForm.bankNo = data.bankNo
      this.mulAcctPayForm.fromBank = data.fromBank
      this.mulAcctPayForm.fund = data.fund
      this.mulAcctPayForm.accountNoSuffix = data.accountNoSuffix
      this.mulAcctPayForm.cashBook = data.cashBook
      this.mulAcctPayForm.gstIO = data.gstIO
      this.mulAcctPayForm.gstStatus = data.gstStatus
      this.mulAcctPayForm.gstRate = data.gstRate
      this.mulAcctPayForm.amountCurr = data.amountCurr
      this.mulAcctPayForm.amount = data.amount
      this.mulAcctPayForm.gstAmountCurr = data.gstAmountCurr
      this.mulAcctPayForm.amountCurrRate = data.amountCurrRate
      this.mulAcctPayForm.gstAmountAE = data.gstAmountAE === 'A'
      this.mulAcctPayForm.gstAmount = data.gstAmount
      this.mulAcctPayForm.netAmountCurr = data.netAmountCurr
      this.mulAcctPayForm.netAmount = data.netAmount
      this.mulAcctPayForm.bankAmountCurr = data.bankAmountCurr
      this.mulAcctPayForm.bankAmountAE = data.bankAmountAE === 'A'
      this.mulAcctPayForm.bankAmount = data.bankAmount
      this.mulAcctPayForm.bankAmountCurrRate = data.bankAmountCurrRate
      this.mulAcctPayForm.bankChargesCurr = data.bankChargesCurr
      this.mulAcctPayForm.bankCharges = data.bankCharges
      this.mulAcctPayForm.bankTotalAmountCurr = data.bankTotalAmountCurr
      this.mulAcctPayForm.bankTotalAmount = data.bankTotalAmount
      this.mulAcctPayForm.bankTotalLocalCurr = data.bankTotalLocalCurr
      this.mulAcctPayForm.bankTotalLocalAE = data.bankTotalLocalAE === 'A'
      this.mulAcctPayForm.bankTotalLocal = data.bankTotalLocal
      this.mulAcctPayForm.bankTotalLocalCurrRate = data.bankTotalLocalCurrRate
      this.mulAcctPayForm.chequeNo = data.chequeNo
      this.mulAcctPayForm.prtCheque = data.prtCheque
      this.mulAcctPayForm.isDeptMand = data.isDeptMand
      this.mulAcctPayForm.printDocument = data.printDocument
      this.mulAcctPayForm.addressTo = data.addressTo
      this.mulAcctPayForm.policyNo = data.policyNo
      this.mulAcctPayForm.insdRefNo = data.insdRefNo
      this.mulAcctPayForm.companyName = data.companyName
      this.mulAcctPayForm.docAddress1 = data.docAddress1
      this.mulAcctPayForm.docAddress2 = data.docAddress2
      this.mulAcctPayForm.docAddress3 = data.docAddress3
      this.mulAcctPayForm.docAddress4 = data.docAddress4
      this.mulAcctPayForm.postalCode = data.postalCode
      this.mulAcctPayForm.details = data.details
      this.mulAcctPayForm.statementRef = data.statementRef
      this.mulAcctPayForm.department = data.department
      this.mulAcctPayForm.insuredName = data.insuredName
      this.mulAcctPayForm.claimNo = data.claimNo
      this.mulAcctPayForm.gstRegNo = data.gstRegNo
      this.mulAcctPayForm.taxInvoiceNo = data.taxInvoiceNo
      this.mulAcctPayForm.isExistDocNo = data.isExistDocNo
      this.mulAcctPayForm.createdBy = await this.fetchUserDetails(data.createdBy)
      this.mulAcctPayForm.createdDate = data.createdDate
      this.mulAcctPayForm.modifiedBy = await this.fetchUserDetails(data.modifiedBy)
      this.mulAcctPayForm.modifiedDate = data.modifiedDate

      this.btnSaveList = true
      if (this.accountList.length <= 1) {
        this.defaultForm.isDisabled = false
        this.headerPanel = [0]
      }
    },
    doRemove(data) {
      if (this.paymentData.tranMode === '' || (this.paymentData.tranMode === 'R' && data.index !== 0)) {
        this.doRemoveRecord(data.item)
        this.doReset()
      } else if (this.paymentData.tranMode === 'R' && data.index === 0) {
        this.promptWarning = true
        this.warningMsg = 'First record not allow to delete'
      }
      if (this.accountList.length === 0) {
        this.tDateRange.effDate = null
      }
    },
    doRemoveRecord(data) {
      for (var i = 0; i < this.accountList.length; i++) {
        if (
          this.accountList[i].branch === data.branch &&
          this.accountList[i].transactionType === data.transactionType &&
          this.accountList[i].documentNo === data.documentNo &&
          this.accountList[i].accountNo === data.accountNo &&
          this.accountList[i].fund === data.fund &&
          this.accountList[i].accountNoSuffix === data.accountNoSuffix
        ) {
          this.$delete(this.accountList, i)
        }
      }
      this.doAccumulate()
      var thisForm = this.reviewForm
      Object.keys(this.reviewForm).forEach(function (key, index) {
        thisForm[key] = null
      })
    },
    doResaveRecord() {
      for (var a = 0; a < this.accountList.length; a++) {
        let bankAmt = 0.0
        let bankTotAmt = 0.0
        if (this.accountList[a].payTo === this.mulAcctPayForm.payTo && this.accountList[a].accountNoSuffix === this.mulAcctPayForm.accountNoSuffix) {
        } else {
          if (this.accountList[a].gstAmountAE === 'A') {
            this.mulAcctPayForm.gstAmount = formatPrice((removeFormatNumber(this.accountList[a].amount) * this.mulAcctPayForm.gstRate) / 100)
          }

          if (this.accountList[a].gstIO === 'B') {
            this.accountList[a].netAmount = formatPrice(Number(removeFormatNumber(this.accountList[a].amount)))
          } else if (this.accountList[a].gstIO === 'I') {
            this.mulAcctPayForm.netAmount = formatPrice(
              Number(removeFormatNumber(this.accountList[a].amount)) + Number(removeFormatNumber(this.accountList[a].gstAmount))
            )
          } else if (this.accountList[a].gstIO === 'O') {
            this.accountList[a].netAmount = formatPrice(
              Number(removeFormatNumber(this.accountList[a].amount)) - Number(removeFormatNumber(this.accountList[a].gstAmount))
            )
          }
          if (this.accountList[a].bankAmountAE === 'A') {
            this.accountList[a].bankAmount = formatPrice(
              (removeFormatNumber(this.accountList[a].netAmount) * this.mulAcctPayForm.amountCurrRate) / this.mulAcctPayForm.bankAmountCurrRate
            )
          }

          this.accountList[a].bankTotalAmount = formatPrice(
            Number(removeFormatNumber(this.accountList[a].bankAmount)) + Number(removeFormatNumber(this.accountList[a].bankCharges))
          )

          if (this.accountList[a].bankTotalLocalAE === 'A') {
            if (this.accountList[a].bankAmountAE) {
              bankAmt =
                (Number(removeFormatNumber(this.accountList[a].netAmount)) * Number(removeFormatNumber(this.mulAcctPayForm.amountCurrRate))) /
                Number(removeFormatNumber(this.mulAcctPayForm.bankAmountCurrRate))
            } else {
              bankAmt = removeFormatNumber(this.accountList[a].bankAmount)
            }
            bankTotAmt = Number(bankAmt) + Number(removeFormatNumber(this.accountList[a].bankCharges))
            bankTotAmt = bankTotAmt * Number(this.mulAcctPayForm.bankAmountCurrRate)
            this.accountList[a].bankTotalLocal = formatPrice(bankTotAmt)
          }
          this.accountList[a].transactionDate = this.mulAcctPayForm.transactionDate
          this.accountList[a].gstStatus = this.mulAcctPayForm.gstStatus
          this.accountList[a].gstRate = this.mulAcctPayForm.gstRate
          this.accountList[a].chequeNo = this.mulAcctPayForm.chequeNo
          this.accountList[a].prtCheque = this.mulAcctPayForm.prtCheque
          this.accountList[a].amountCurrRate = this.mulAcctPayForm.amountCurrRate
          this.accountList[a].bankAmountCurrRate = this.mulAcctPayForm.bankAmountCurrRate
          this.accountList[a].saveStatus = 'true'
        }
      }
      this.defaultForm.transactionDate = this.mulAcctPayForm.transactionDate
      this.defaultForm.gstStatus = this.mulAcctPayForm.gstStatus
      this.defaultForm.gstRate = this.mulAcctPayForm.gstRate
      this.defaultForm.chequeNo = this.mulAcctPayForm.chequeNo
      this.defaultForm.prtCheque = this.mulAcctPayForm.prtCheque
      this.defaultForm.amountCurrRate = this.mulAcctPayForm.amountCurrRate
      this.defaultForm.bankAmountCurrRate = this.mulAcctPayForm.bankAmountCurrRate
    },
    doSaveAccount() {
      let addRecord = true
      this.existAcctPay = false
      this.processingFlag = true
      if (this.initDisabled) {
        this.doResaveRecord()
      }
      for (var i = 0; i < this.accountList.length; i++) {
        if (this.accountList[i].accountNo === this.reviewForm.accountNo && this.accountList[i].accountNoSuffix === this.reviewForm.accountNoSuffix) {
          this.checkChequeNo()
          addRecord = false
        } else {
          if (
            this.accountList[i].accountNo === this.mulAcctPayForm.accountNo &&
            this.accountList[i].accountNoSuffix === this.mulAcctPayForm.accountNoSuffix
          ) {
            this.duplicateForm.acctNo = this.mulAcctPayForm.accountNo
            this.duplicateForm.suffix = this.mulAcctPayForm.accountNoSuffix
            this.promptDuplicateAccount = true
            this.existAcctPay = true
            addRecord = false
          }
        }
      }
      if (addRecord) {
        this.checkChequeNo()
      }
    },
    doCancelAccount() {
      if (this.accountList.length <= 1) {
        this.defaultForm.isDisabled = true
        this.defaultForm.branch = this.mulAcctPayForm.branch
        this.defaultForm.documentNo = this.mulAcctPayForm.documentNo
        this.defaultForm.transactionType = this.mulAcctPayForm.transactionType
        this.defaultForm.docAE = this.mulAcctPayForm.docAE
        this.defaultForm.transactionDate = this.mulAcctPayForm.transactionDate
        this.defaultForm.chequeNo = this.mulAcctPayForm.chequeNo
        this.defaultForm.prtCheque = this.mulAcctPayForm.prtCheque
        this.defaultForm.fromBank = this.mulAcctPayForm.fromBank
        this.defaultForm.fund = this.mulAcctPayForm.fund
        this.defaultForm.gstIO = this.mulAcctPayForm.gstIO
        this.defaultForm.gstStatus = this.mulAcctPayForm.gstStatus
        this.defaultForm.gstRate = this.mulAcctPayForm.gstRate
        this.defaultForm.amountCurr = this.mulAcctPayForm.amountCurr
        this.defaultForm.amountCurrRate = this.mulAcctPayForm.amountCurrRate
        this.defaultForm.bankAmountCurr = this.mulAcctPayForm.bankAmountCurr
        this.defaultForm.bankAmountCurrRate = this.mulAcctPayForm.bankAmountCurrRate
        this.defaultForm.bankChargesCurr = this.mulAcctPayForm.bankChargesCurr
        this.defaultForm.bankTotalAmountCurr = this.mulAcctPayForm.bankTotalAmountCurr
        this.defaultForm.bankTotalLocalCurr = this.mulAcctPayForm.bankTotalLocalCurr
        this.defaultForm.printDocument = this.mulAcctPayForm.printDocument
      }
      this.doReset()
    },
    doAccumulate() {
      this.grandTotForm.payment = '0.00'
      this.grandTotForm.gst = '0.00'
      this.grandTotForm.net = '0.00'
      this.grandTotForm.bankAmt = '0.00'
      this.grandTotForm.charges = '0.00'
      this.grandTotForm.total = '0.00'
      this.grandTotForm.localTotal = '0.00'

      for (var i = 0; i < this.accountList.length; i++) {
        this.grandTotForm.payment = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.payment)) + Number(removeFormatNumber(this.accountList[i].amount))
        )
        this.grandTotForm.gst = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.gst)) + Number(removeFormatNumber(this.accountList[i].gstAmount))
        )
        this.grandTotForm.net = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.net)) + Number(removeFormatNumber(this.accountList[i].netAmount))
        )
        this.grandTotForm.bankAmt = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.bankAmt)) + Number(removeFormatNumber(this.accountList[i].bankAmount))
        )
        this.grandTotForm.charges = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.charges)) + Number(removeFormatNumber(this.accountList[i].bankCharges))
        )
        this.grandTotForm.total = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.total)) + Number(removeFormatNumber(this.accountList[i].bankTotalAmount))
        )
        this.grandTotForm.localTotal = formatPrice(
          Number(removeFormatNumber(this.grandTotForm.localTotal)) + Number(removeFormatNumber(this.accountList[i].bankTotalLocal))
        )
      }
    },
    closeDupAcctDialog() {
      this.promptDuplicateAccount = false
    },
    doProceed() {
      this.promptConfirmation = false
      this.doValidateMulAcctForm()
    },
    checkDocNo() {
      this.isDocNoExist(this.mulAcctPayForm)
    },
    currencyChange() {
      this.mulAcctPayForm.gstAmountCurr = this.mulAcctPayForm.amountCurr
      this.mulAcctPayForm.netAmountCurr = this.mulAcctPayForm.amountCurr
    },
    changeGstIO(gstIO) {
      this.mulAcctPayForm.gstIO = gstIO
      if (this.mulAcctPayForm.gstIO === 'B') {
        this.mulAcctPayForm.gstStatus = 'B'
        this.mulAcctPayForm.gstAmount = (0.0).toFixed(2)
        this.mulAcctPayForm.gstRate = (0.0).toFixed(2)
      } else {
        this.mulAcctPayForm.gstStatus = 'M'
        this.getCommonData('gstrate', this.mulAcctPayForm.gstStatus, formatDisplayDateTime2(this.mulAcctPayForm.transactionDate))
      }
      this.calculateAmount()
    },
    changeGstRate(gstStatus) {
      this.getCommonData('gstrate', gstStatus, formatDisplayDateTime2(this.mulAcctPayForm.transactionDate))
    },
    setAmount() {
      this.$refs.amount.$el.cleave.setRawValue(this.mulAcctPayForm.amount)
      this.mulAcctPayForm.amount = formatPrice(this.$refs.amount.$el.cleave.getRawValue())
      this.$refs.gstAmount.$el.cleave.setRawValue(this.mulAcctPayForm.gstAmount)
      this.mulAcctPayForm.gstAmount = formatPrice(this.$refs.gstAmount.$el.cleave.getRawValue())
      this.$refs.bankAmount.$el.cleave.setRawValue(this.mulAcctPayForm.bankAmount)
      this.mulAcctPayForm.bankAmount = formatPrice(this.$refs.bankAmount.$el.cleave.getRawValue())
      this.$refs.bankCharges.$el.cleave.setRawValue(this.mulAcctPayForm.bankCharges)
      this.mulAcctPayForm.bankCharges = formatPrice(this.$refs.bankCharges.$el.cleave.getRawValue())
      this.$refs.bankTotalLocal.$el.cleave.setRawValue(this.mulAcctPayForm.bankTotalLocal)
      this.mulAcctPayForm.bankTotalLocal = formatPrice(this.$refs.bankTotalLocal.$el.cleave.getRawValue())
      this.$refs.bankTotalAmount.$el.cleave.setRawValue(this.mulAcctPayForm.bankTotalAmount)
      this.mulAcctPayForm.bankTotalAmount = formatPrice(this.$refs.bankTotalAmount.$el.cleave.getRawValue())
    },
    doMandatory(tabId) {
      if (this.isMandatory === false) {
        this.$validator.validateAll('paymentOptionalForm').then((result) => {
          if (result) {
            this.isMandatory = true
            this.isOptional = false
            this.validStatus.optional = true
            this.validStatus.mandatory = true
            this.tabNav = tabId
          } else {
            if (this.isMandatory === true && this.isOptional === false) {
              this.validStatus.optional = true
              this.tabNav = 0
            } else {
              this.validStatus.optional = false
              this.tabNav = 1
            }
            this.processingFlag = false
          }
        })
      }
    },
    doOptionalA() {
      if (this.isMandatory === false && this.isOptional === true) {
        this.validStatus.mandatory = true
        this.tabNav = 1
      } else {
        this.validStatus.mandatory = false
        this.tabNav = 0
      }
    },
    doOptional(tabId) {
      if (this.isOptional === false) {
        this.$validator.validateAll('paymentMandatoryForm').then((result) => {
          if (result) {
            this.ValidateTranDateRange(this.mulAcctPayForm.transactionDate, '004').then((result) => {
              if (result) {
                if (this.paymentData.tranMode !== 'R') {
                  this.validateIntermediary(this.mulAcctPayForm.transactionDate, this.mulAcctPayForm.payTo).then(() => {
                    if (this.promptMsg === false || this.acceptInterWarn === true) {
                      this.isMandatory = false
                      this.isOptional = true
                      this.validStatus.mandatory = true
                      this.validStatus.optional = true
                      this.tabNav = tabId
                    } else {
                      this.doOptionalA()
                    }
                  })
                } else {
                  this.isMandatory = false
                  this.isOptional = true
                  this.validStatus.mandatory = true
                  this.validStatus.optional = true
                  this.tabNav = tabId
                }
              } else {
                this.doOptionalA()
              }
            })
          } else {
            this.doOptionalA()
            this.promptFieldCheck()
          }
        })
      }
    },
    calculateAmount() {
      let bankAmt = 0.0
      let bankTotAmt = 0.0
      // let bankCharges = 0.00
      if (this.mulAcctPayForm.gstAmountAE) {
        this.mulAcctPayForm.gstAmount = formatPrice((removeFormatNumber(this.mulAcctPayForm.amount) * this.mulAcctPayForm.gstRate) / 100)
      }

      if (this.mulAcctPayForm.gstIO === 'B') {
        this.mulAcctPayForm.netAmount = formatPrice(Number(removeFormatNumber(this.mulAcctPayForm.amount)))
      } else if (this.mulAcctPayForm.gstIO === 'I') {
        this.mulAcctPayForm.netAmount = formatPrice(
          Number(removeFormatNumber(this.mulAcctPayForm.amount)) + Number(removeFormatNumber(this.mulAcctPayForm.gstAmount))
        )
      } else if (this.mulAcctPayForm.gstIO === 'O') {
        this.mulAcctPayForm.netAmount = formatPrice(
          Number(removeFormatNumber(this.mulAcctPayForm.amount)) - Number(removeFormatNumber(this.mulAcctPayForm.gstAmount))
        )
      }
      if (this.mulAcctPayForm.bankAmountAE) {
        this.mulAcctPayForm.bankAmount = formatPrice(
          (removeFormatNumber(this.mulAcctPayForm.netAmount) * this.mulAcctPayForm.amountCurrRate) / this.mulAcctPayForm.bankAmountCurrRate
        )
      }

      this.mulAcctPayForm.bankTotalAmount = formatPrice(
        Number(removeFormatNumber(this.mulAcctPayForm.bankAmount)) + Number(removeFormatNumber(this.mulAcctPayForm.bankCharges))
      )

      if (this.mulAcctPayForm.bankTotalLocalAE) {
        // this.mulAcctPayForm.bankTotalLocal = formatPrice(removeFormatNumber(this.mulAcctPayForm.bankTotalAmount) * Number(this.mulAcctPayForm.bankAmountCurrRate))
        // bankAmt = ((removeFormatNumber(this.mulAcctPayForm.netAmount) * this.mulAcctPayForm.amountCurrRate) / this.mulAcctPayForm.bankAmountCurrRate)
        // bankCharges = Number(this.mulAcctPayForm.bankCharges).toFixed(3)
        // bankTotAmt = Number(bankAmt).toFixed(3) + Number(bankCharges)
        // this.mulAcctPayForm.bankTotalLocal = bankTotAmt * Number(this.mulAcctPayForm.bankAmountCurrRate)
        if (this.mulAcctPayForm.bankAmountAE) {
          bankAmt =
            (Number(removeFormatNumber(this.mulAcctPayForm.netAmount)) * Number(removeFormatNumber(this.mulAcctPayForm.amountCurrRate))) /
            Number(removeFormatNumber(this.mulAcctPayForm.bankAmountCurrRate))
        } else {
          bankAmt = removeFormatNumber(this.mulAcctPayForm.bankAmount)
        }
        bankTotAmt = Number(bankAmt) + Number(removeFormatNumber(this.mulAcctPayForm.bankCharges))
        bankTotAmt = bankTotAmt * Number(this.mulAcctPayForm.bankAmountCurrRate)
        this.mulAcctPayForm.bankTotalLocal = formatPrice(bankTotAmt)
      }
      this.setAmount()
    },
    checkChequeNo() {
      if (
        this.mulAcctPayForm.chequeNo !== null &&
        this.mulAcctPayForm.chequeNo !== '' &&
        (this.defaultForm.isDisabled === false || this.initDisabled)
      ) {
        this.getAcctMasterPaytChequeNo(this.mulAcctPayForm).then((result) => {
          if (result) {
            if (this.isExistChequeNo === 'true') {
              this.promptConfirmation = true
            } else {
              this.doValidateMulAcctForm()
            }
          } else {
            this.processingFlag = true
          }
        })
      } else {
        this.doValidateMulAcctForm()
      }
    },
    doCancel() {
      this.$router.push({ name: 'mulAcctPayment' }).catch(() => {})
    },
    closeDialog() {
      this.promptWarning = false
    },
    doSavePayment(actionName) {
      this.mulAcctPayForm.actionName = actionName
      this.processingFlag = true
      if (this.paymentData.tranMode === 'R') {
        if (actionName === 'CREATE_SAVE_REVIEW') {
          this.mulAcctPayForm.actionName = 'UPDATE_SAVE_REVIEW'
        } else if (actionName === 'CREATE_SAVE_POST') {
          this.mulAcctPayForm.actionName = 'UPDATE_SAVE_POST'
        } else if (actionName === 'CREATE_MATCH_LATER') {
          this.mulAcctPayForm.actionName = 'UPDATE_MATCH_LATER'
        }
      }
      if (this.accountList.length > 0) {
        this.mulAcctPayForm.accountList = this.accountList
        this.performSaveMultAcctPayt()
      } else {
        this.warningMsg = 'No Payment Record to be save.'
        this.processingFlag = false
        this.promptWarning = true
      }
    },
    doValidateMulAcctForm() {
      this.mulAcctPayForm.bankNo = this.mulAcctPayForm.fromBank

      this.$validator.validateAll('paymentMandatoryForm').then((result) => {
        if (result) {
          this.ValidateTranDateRange(this.mulAcctPayForm.transactionDate, '004').then((result) => {
            if (result) {
              if (this.paymentData.tranMode !== 'R') {
                this.validateIntermediary(this.mulAcctPayForm.transactionDate, this.mulAcctPayForm.payTo).then(() => {
                  if (this.promptMsg === false || this.acceptInterWarn === true) {
                    this.isMandatory = false
                    this.isOptional = true
                    this.$validator.validateAll('paymentOptionalForm').then((result) => {
                      if (result) {
                        this.isMandatory = true
                        this.isOptional = false
                        if (this.mulAcctPayForm.policyNo !== null && this.mulAcctPayForm.policyNo !== '') {
                          this.ValidatePolicyNo(this.mulAcctPayForm.policyNo, this.mulAcctPayForm.accountNo).then((result) => {
                            if (result) {
                              if (this.existAcctPay === false) {
                                this.doRemoveRecord(this.reviewForm)
                                this.doProceedSaveMulAcct()
                              }
                            }
                          })
                        } else {
                          if (this.existAcctPay === false) {
                            this.doRemoveRecord(this.reviewForm)
                            this.doProceedSaveMulAcct()
                          }
                        }
                      } else {
                        this.validStatus.optional = false
                        this.tabNav = 1
                      }
                    })
                  } else {
                    this.validStatus.mandatory = false
                    this.tabNav = 0
                  }
                })
              } else {
                this.isMandatory = false
                this.isOptional = true
                this.$validator.validateAll('paymentOptionalForm').then((result) => {
                  if (result) {
                    this.isMandatory = true
                    this.isOptional = false
                    if (this.mulAcctPayForm.policyNo !== null && this.mulAcctPayForm.policyNo !== '') {
                      this.ValidatePolicyNo(this.mulAcctPayForm.policyNo, this.mulAcctPayForm.accountNo).then((result) => {
                        if (result) {
                          if (this.existAcctPay === false) {
                            this.doRemoveRecord(this.reviewForm)
                            this.doProceedSaveMulAcct()
                          }
                        }
                      })
                    } else {
                      if (this.existAcctPay === false) {
                        this.doRemoveRecord(this.reviewForm)
                        this.doProceedSaveMulAcct()
                      }
                    }
                  } else {
                    this.validStatus.optional = false
                    this.processingFlag = false
                    this.tabNav = 1
                  }
                })
                this.processingFlag = false
              }
            } else {
              this.validStatus.mandatory = false
              this.processingFlag = false
              this.tabNav = 0
            }
          })
        } else {
          this.validStatus.mandatory = false
          this.tabNav = 0
          this.promptFieldCheck()
        }
      })
      this.processingFlag = false
    },
    parseDateISO(value) {
      if (value) {
        return parseISO(value)
      }
    },
    assignAcctInfo(data) {
      this.mulAcctPayForm.payTo = data.inter
      if (this.mulAcctPayForm.addressTo === 'A') {
        this.mulAcctPayForm.accountNo = data.inter
        this.mulAcctPayForm.gstRegNo = data.gstRegNo
        this.mulAcctPayForm.companyName = data.name
        this.mulAcctPayForm.docAddress1 = data.address1
        this.mulAcctPayForm.docAddress2 = data.address2
        this.mulAcctPayForm.docAddress3 = data.address3
        this.mulAcctPayForm.docAddress4 = data.address4
        this.mulAcctPayForm.postalCode = data.postalCode
      }
      this.showPayToHelpList = false
    },
    assignBankInfo(data) {
      this.mulAcctPayForm.bankNo = data.defPayBank
      this.mulAcctPayForm.fromBank = data.defPayBank
      this.mulAcctPayForm.fund = data.bankFund
      this.mulAcctPayForm.accountNoSuffix = data.bankAcctNoSfx
      this.mulAcctPayForm.amountCurr = data.bankAcctCurrency
      this.mulAcctPayForm.amountCurrRate = data.bankCurrRate
      this.mulAcctPayForm.gstAmountCurr = data.bankAcctCurrency
      this.mulAcctPayForm.netAmountCurr = data.bankAcctCurrency
      this.mulAcctPayForm.bankAmountCurr = data.bankAcctCurrency
      this.mulAcctPayForm.bankAmountCurrRate = data.bankCurrRate
      this.mulAcctPayForm.bankChargesCurr = data.bankAcctCurrency
      this.mulAcctPayForm.bankTotalAmountCurr = data.bankAcctCurrency
      this.payBankCurr = data.payBankCurr
      this.showBankNoHelpList = false
      this.checkTotAmtCurrCompanyCurr()
      this.calculateAmount()
    },
    assignAcctSufInfo(data) {
      this.mulAcctPayForm.accountNoSuffix = data.acctNoSfx
      this.showAcctSufHelpList = false
    },
    assignCurrencyInfo(data) {
      this.mulAcctPayForm.amountCurr = data.curr
      this.mulAcctPayForm.gstAmountCurr = data.curr
      this.mulAcctPayForm.netAmountCurr = data.curr
      this.mulAcctPayForm.amountCurrRate = data.currRate
      this.showCurrencyHelpList = false

      this.calculateAmount()
    },
    assignPolicyInfo(data) {
      this.mulAcctPayForm.policyNo = data.policyNo + '-' + data.renCnt + '-' + data.endtCnt
      this.mulAcctPayForm.insuredName = data.insuredName
      this.mulAcctPayForm.insdRefNo = data.insdRefNo
      if (this.mulAcctPayForm.addressTo === 'I') {
        this.mulAcctPayForm.companyName = data.fullName
        this.mulAcctPayForm.docAddress1 = data.address1
        this.mulAcctPayForm.docAddress2 = data.address2
        this.mulAcctPayForm.docAddress3 = data.address3
        this.mulAcctPayForm.docAddress4 = data.address4
        this.mulAcctPayForm.postalCode = data.postalCode
      }
      this.showAcctPolicyHelpList = false
    },
    assignClaimNo(claimNo) {
      this.mulAcctPayForm.claimNo = claimNo
      this.showClmHelpList = false
    },
    assignGSTRate(data) {
      this.mulAcctPayForm.gstRate = formatPrice(data)
      this.calculateAmount()
    },
    doRemoveNameAddr() {
      this.mulAcctPayForm.companyName = ''
      this.mulAcctPayForm.docAddress1 = ''
      this.mulAcctPayForm.docAddress2 = ''
      this.mulAcctPayForm.docAddress3 = ''
      this.mulAcctPayForm.docAddress4 = ''
      this.mulAcctPayForm.postalCode = ''
    },
    async getPayToAcctInfo(acctNo) {
      this.getCommonData('accountdata', acctNo)
    },
    async getBankInfo(bankNo) {
      this.getCommonData('bankdata', bankNo, formatDisplayDateTime2(this.mulAcctPayForm.transactionDate))
    },
    async getAcctNoSfxInfo(acctNoSfx) {
      this.getCommonData('acctnosuffixdata', acctNoSfx)
    },
    assignBankCurrRate(data) {
      this.mulAcctPayForm.bankAmountCurrRate = data.bankCurrRate
      this.calculateAmount()
    },
    assignCurrRate(currRate) {
      this.mulAcctPayForm.amountCurrRate = currRate
      this.mulAcctPayForm.gstAmountCurr = this.mulAcctPayForm.amountCurr
      this.mulAcctPayForm.netAmountCurr = this.mulAcctPayForm.amountCurr
      this.calculateAmount()
    }
  },
  created() {
    this.$validator.extend('documentNo', {
      getMessage(field, args) {
        return 'This Payment No. already exists.'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var isdocNoExist = args[0]
        if (isdocNoExist === 'true') {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('chequeNo', {
      getMessage(field, args) {
        return 'This Cheque No. exceed Cheque No. Form'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var cheqNoForm = args[0]
        if (cheqNoForm > 0) {
          if (value.length > cheqNoForm) {
            return false
          } else {
            return true
          }
        }
      }
    })
  },
  mounted() {
    this.doInit()
  },
  mixins: [
    routeMixin,
    MessageMixin,
    commonAjaxMixin,
    promptOnExitMixin,
    mulAcctPaymentAjaxMixin,
    mulAcctPaymentViewMixin,
    paymentAjaxMixin,
    TableConst.default
  ],
  components: {
    AcctNoHelpList,
    BankHelpList,
    AcctSufHelpList,
    CurrencyHelpList,
    AcctPolicyHelpList,
    ClaimHelpList,
    PromptLeave,
    SanctionPartialMatchList
  }
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
